import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import InfoLayout from "@/components/InfoLayout";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";

export default function FAQ() {
  const [faqs, setFaqs] = useState(null);

  useEffect(() => {
    api.get("/faqs").then((r) => setFaqs(r.data)).catch(() => setFaqs([]));
  }, []);

  return (
    <InfoLayout title="Frequently asked questions" subtitle="Answers about QR codes, reference pages, privacy, and accounts.">
      {faqs === null ? (
        <div className="flex justify-center py-10"><Loader2 className="h-6 w-6 animate-spin text-[#0D9488]" /></div>
      ) : (
        <Accordion type="single" collapsible data-testid="faq-accordion">
          {faqs.map((f) => (
            <AccordionItem key={f.id} value={f.id}>
              <AccordionTrigger className="text-left text-base font-medium text-slate-900">{f.question}</AccordionTrigger>
              <AccordionContent className="text-sm leading-relaxed text-slate-600">{f.answer}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      )}
      <div className="pt-4">
        <p className="text-sm text-slate-600">Still have questions?</p>
        <Button asChild variant="outline" className="mt-3"><Link to="/contact">Contact support</Link></Button>
      </div>
    </InfoLayout>
  );
}
